import React from 'react'
import PlaceholderPage from '../../components/shared/PlaceholderPage'
import { Briefcase } from 'lucide-react'

const features = [
  { name: 'Project Timeline', description: 'Visual timeline with milestones' },
  { name: 'Task Management', description: 'Break projects into manageable tasks' },
  { name: 'Team Assignments', description: 'Assign team members to projects' },
  { name: 'Progress Tracking', description: 'Monitor project completion and health' },
]

export default function ProjectsView() {
  return (
    <PlaceholderPage
      title="Projects"
      description="Manage customer projects and deliverables"
      icon={Briefcase}
      features={features}
      accentColor="emerald"
    />
  )
}
